import React from 'react';
import { SvgIcon } from '../../components/svgIcon';
import { SvgIconProps } from '../../components/svgIcon/model';

export const MoneyHatchedIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon
      // cacheName="hatched/money"
      ref={ref as any}
      {...props}
    >
      <mask height="22" id="mask0_302_2" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }} width="22" x="4" y="3">
        <path
          d="M5 23.5936C6.45881 18.8554 7.88626 16.072 8.9686 14.3675C9.34509 13.789 9.95685 12.8663 10.7412 11.3964C11.7294 9.55125 11.949 8.73809 12.8901 7.018C13.3137 6.23613 13.9254 5.18843 14.7725 4"
          fill="#FFCEC3"
        />
        <path
          d="M5 23.5936C6.45881 18.8554 7.88626 16.072 8.9686 14.3675C9.34509 13.789 9.95685 12.8663 10.7412 11.3964C11.7294 9.55125 11.949 8.73809 12.8901 7.018C13.3137 6.23613 13.9254 5.18843 14.7725 4"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M5 19.3245C5.54902 18.3394 5.97254 17.495 6.30195 16.8226C6.59999 16.1971 7.05489 15.2588 7.55685 14.0079C8.05881 12.7569 8.07449 12.5223 8.49802 11.6623C8.95292 10.724 9.04705 10.7866 9.48623 9.89528C10.0509 8.73809 9.90977 8.62864 10.5372 7.28383C11.0392 6.18922 11.5098 5.46991 11.6823 5.20407C12.0117 4.70368 12.3255 4.29711 12.5764 4"
          fill="#FFCEC3"
        />
        <path
          d="M5 19.3245C5.54902 18.3394 5.97254 17.495 6.30195 16.8226C6.59999 16.1971 7.05489 15.2588 7.55685 14.0079C8.05881 12.7569 8.07449 12.5223 8.49802 11.6623C8.95292 10.724 9.04705 10.7866 9.48623 9.89528C10.0509 8.73809 9.90977 8.62864 10.5372 7.28383C11.0392 6.18922 11.5098 5.46991 11.6823 5.20407C12.0117 4.70368 12.3255 4.29711 12.5764 4"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M5 16.0407C5.15686 15.556 5.43921 14.7585 5.84705 13.8202C6.27058 12.8664 6.41176 12.6943 7.10195 11.2088C7.58822 10.1611 7.58822 10.0986 8.15292 8.91011C8.63919 7.87804 8.749 7.6904 9.06273 7.03364C9.39214 6.3456 9.84704 5.31354 10.3176 4"
          fill="#FFCEC3"
        />
        <path
          d="M5 16.0407C5.15686 15.556 5.43921 14.7585 5.84705 13.8202C6.27058 12.8664 6.41176 12.6943 7.10195 11.2088C7.58822 10.1611 7.58822 10.0986 8.15292 8.91011C8.63919 7.87804 8.749 7.6904 9.06273 7.03364C9.39214 6.3456 9.84704 5.31354 10.3176 4"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M5 11.9435C5.48627 10.7707 5.94117 9.83244 6.27058 9.20697C6.8196 8.12797 7.10195 7.6745 7.63528 6.64244C8.1843 5.53219 8.57645 4.60959 8.82742 4.01537"
          fill="#FFCEC3"
        />
        <path
          d="M5 11.9435C5.48627 10.7707 5.94117 9.83244 6.27058 9.20697C6.8196 8.12797 7.10195 7.6745 7.63528 6.64244C8.1843 5.53219 8.57645 4.60959 8.82742 4.01537"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M5 8.61273C5.21961 8.15927 5.43921 7.70577 5.64313 7.22102C5.98823 6.43915 6.09803 6.09513 6.41176 5.42273C6.56862 5.06307 6.80391 4.57831 7.10195 4.01537"
          fill="#FFCEC3"
        />
        <path
          d="M5 8.61273C5.21961 8.15927 5.43921 7.70577 5.64313 7.22102C5.98823 6.43915 6.09803 6.09513 6.41176 5.42273C6.56862 5.06307 6.80391 4.57831 7.10195 4.01537"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M5 5.28199C5.1098 5.14126 5.26667 4.93797 5.39216 4.68777C5.51764 4.42194 5.59608 4.18738 5.64313 4.01537"
          fill="#FFCEC3"
        />
        <path
          d="M5 5.28199C5.1098 5.14126 5.26667 4.93797 5.39216 4.68777C5.51764 4.42194 5.59608 4.18738 5.64313 4.01537"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M6.19211 23.9063C6.41171 23.5466 6.75681 22.9837 7.10191 22.2487C7.72936 20.9352 7.82347 20.2628 8.38817 18.8398C8.89014 17.5732 9.37641 16.6506 9.64309 16.1658C10.4901 14.5864 10.7411 14.5396 11.7293 12.8038C12.498 11.459 12.3411 11.5059 13.2666 9.84835C14.1293 8.2846 14.396 8.0188 14.9764 6.8929C15.5881 5.68883 15.9803 4.64113 16.1999 4"
          fill="#FFCEC3"
        />
        <path
          d="M6.19211 23.9063C6.41171 23.5466 6.75681 22.9837 7.10191 22.2487C7.72936 20.9352 7.82347 20.2628 8.38817 18.8398C8.89014 17.5732 9.37641 16.6506 9.64309 16.1658C10.4901 14.5864 10.7411 14.5396 11.7293 12.8038C12.498 11.459 12.3411 11.5059 13.2666 9.84835C14.1293 8.2846 14.396 8.0188 14.9764 6.8929C15.5881 5.68883 15.9803 4.64113 16.1999 4"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M7.72948 23.9063C8.09026 23.4684 8.6079 22.796 9.1569 21.9047C10.1452 20.2941 10.2549 19.5122 11.4157 16.8695C12.0902 15.337 12.4824 14.4614 13.1569 13.2885C13.9726 11.8812 14.1922 11.8187 15.353 9.87961C15.9177 8.95704 16.4823 8.00317 17.0941 6.68962C17.5961 5.61064 17.9412 4.68804 18.1765 4"
          fill="#FFCEC3"
        />
        <path
          d="M7.72948 23.9063C8.09026 23.4684 8.6079 22.796 9.1569 21.9047C10.1452 20.2941 10.2549 19.5122 11.4157 16.8695C12.0902 15.337 12.4824 14.4614 13.1569 13.2885C13.9726 11.8812 14.1922 11.8187 15.353 9.87961C15.9177 8.95704 16.4823 8.00317 17.0941 6.68962C17.5961 5.61064 17.9412 4.68804 18.1765 4"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M10.0197 23.9063C10.2863 23.3277 10.6314 22.5615 11.0706 21.6701C12.0902 19.5122 12.8902 17.9172 13.0942 17.5419C13.5177 16.7131 14.2549 15.2588 15.2118 13.4762C16.2941 11.4746 16.4823 11.24 17.2667 9.69196C17.8314 8.58171 18.302 7.6122 18.6941 6.81469C19.2274 5.70445 19.6823 4.75057 20.0117 4.01562"
          fill="#FFCEC3"
        />
        <path
          d="M10.0197 23.9063C10.2863 23.3277 10.6314 22.5615 11.0706 21.6701C12.0902 19.5122 12.8902 17.9172 13.0942 17.5419C13.5177 16.7131 14.2549 15.2588 15.2118 13.4762C16.2941 11.4746 16.4823 11.24 17.2667 9.69196C17.8314 8.58171 18.302 7.6122 18.6941 6.81469C19.2274 5.70445 19.6823 4.75057 20.0117 4.01562"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M24.9999 4.39096C23.5411 9.12905 22.1136 11.9125 21.0313 13.617C20.6548 14.1956 20.0431 15.1182 19.2588 16.588C18.2705 18.4333 18.0509 19.2464 17.1098 20.9665C16.6862 21.7484 16.0745 22.7961 15.2274 23.9845"
          fill="#FFCEC3"
        />
        <path
          d="M24.9999 4.39096C23.5411 9.12905 22.1136 11.9125 21.0313 13.617C20.6548 14.1956 20.0431 15.1182 19.2588 16.588C18.2705 18.4333 18.0509 19.2464 17.1098 20.9665C16.6862 21.7484 16.0745 22.7961 15.2274 23.9845"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M25 8.6754C24.451 9.66058 24.0117 10.505 23.698 11.1774C23.4 11.8029 22.9451 12.7411 22.4431 13.9921C21.9411 15.2431 21.9255 15.4776 21.502 16.3377C21.0471 17.2759 20.9529 17.2134 20.5137 18.1047C19.9333 19.2462 20.0745 19.3713 19.4628 20.7005C18.9608 21.7951 18.4902 22.5144 18.3176 22.7803C17.9882 23.2807 17.6745 23.6872 17.4235 23.9843"
          fill="#FFCEC3"
        />
        <path
          d="M25 8.6754C24.451 9.66058 24.0117 10.505 23.698 11.1774C23.4 11.8029 22.9451 12.7411 22.4431 13.9921C21.9411 15.2431 21.9255 15.4776 21.502 16.3377C21.0471 17.2759 20.9529 17.2134 20.5137 18.1047C19.9333 19.2462 20.0745 19.3713 19.4628 20.7005C18.9608 21.7951 18.4902 22.5144 18.3176 22.7803C17.9882 23.2807 17.6745 23.6872 17.4235 23.9843"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M25 11.9593C24.8431 12.444 24.5608 13.2415 24.1529 14.1798C23.7294 15.1336 23.5882 15.3057 22.898 16.7912C22.4118 17.8389 22.4118 17.9015 21.847 19.0899C21.3608 20.122 21.251 20.3096 20.9372 20.9664C20.6078 21.6544 20.1529 22.6865 19.6823 24"
          fill="#FFCEC3"
        />
        <path
          d="M25 11.9593C24.8431 12.444 24.5608 13.2415 24.1529 14.1798C23.7294 15.1336 23.5882 15.3057 22.898 16.7912C22.4118 17.8389 22.4118 17.9015 21.847 19.0899C21.3608 20.122 21.251 20.3096 20.9372 20.9664C20.6078 21.6544 20.1529 22.6865 19.6823 24"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M24.9998 16.0563C24.4979 17.2291 24.043 18.1673 23.7293 18.7928C23.1802 19.8718 22.8979 20.3252 22.3646 21.3573C21.8155 22.4676 21.4234 23.3902 21.1724 23.9844"
          fill="#FFCEC3"
        />
        <path
          d="M24.9998 16.0563C24.4979 17.2291 24.043 18.1673 23.7293 18.7928C23.1802 19.8718 22.8979 20.3252 22.3646 21.3573C21.8155 22.4676 21.4234 23.3902 21.1724 23.9844"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M24.9998 19.3872C24.7802 19.8406 24.5606 20.2941 24.3567 20.7789C24.0116 21.5608 23.9018 21.9048 23.5881 22.5772C23.4312 22.9368 23.1959 23.4216 22.8979 23.9845"
          fill="#FFCEC3"
        />
        <path
          d="M24.9998 19.3872C24.7802 19.8406 24.5606 20.2941 24.3567 20.7789C24.0116 21.5608 23.9018 21.9048 23.5881 22.5772C23.4312 22.9368 23.1959 23.4216 22.8979 23.9845"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M24.9998 22.7179C24.8744 22.8587 24.7332 23.0463 24.592 23.3121C24.4665 23.578 24.3881 23.8125 24.341 23.9846"
          fill="#FFCEC3"
        />
        <path
          d="M24.9998 22.7179C24.8744 22.8587 24.7332 23.0463 24.592 23.3121C24.4665 23.578 24.3881 23.8125 24.341 23.9846"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M23.7921 4.07827C23.5725 4.43793 23.2274 5.00087 22.8823 5.72019C22.2548 7.03372 22.1607 7.70612 21.596 9.12913C21.0941 10.3957 20.6078 11.3184 20.3411 11.8031C19.4941 13.3825 19.2431 13.4294 18.2549 15.1651C17.4863 16.5099 17.6431 16.463 16.7176 18.1206C15.8549 19.6843 15.5882 19.9501 15.0078 21.076C14.3961 22.2801 14.0039 23.3278 13.7843 23.9689"
          fill="#FFCEC3"
        />
        <path
          d="M23.7921 4.07827C23.5725 4.43793 23.2274 5.00087 22.8823 5.72019C22.2548 7.03372 22.1607 7.70612 21.596 9.12913C21.0941 10.3957 20.6078 11.3184 20.3411 11.8031C19.4941 13.3825 19.2431 13.4294 18.2549 15.1651C17.4863 16.5099 17.6431 16.463 16.7176 18.1206C15.8549 19.6843 15.5882 19.9501 15.0078 21.076C14.3961 22.2801 14.0039 23.3278 13.7843 23.9689"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
        <path
          d="M22.2704 4.07827C21.9096 4.51611 21.392 5.18851 20.843 6.07984C19.8547 7.69048 19.7449 8.47237 18.5842 11.1151C17.9096 12.6475 17.5175 13.5232 16.843 14.696C16.0273 16.1033 15.8077 16.1659 14.6469 18.1049C14.0822 19.0275 13.5175 19.9814 12.9057 21.2949C12.4038 22.3739 12.0587 23.2965 11.8234 23.9846"
          fill="#FFCEC3"
        />
        <path
          d="M22.2704 4.07827C21.9096 4.51611 21.392 5.18851 20.843 6.07984C19.8547 7.69048 19.7449 8.47237 18.5842 11.1151C17.9096 12.6475 17.5175 13.5232 16.843 14.696C16.0273 16.1033 15.8077 16.1659 14.6469 18.1049C14.0822 19.0275 13.5175 19.9814 12.9057 21.2949C12.4038 22.3739 12.0587 23.2965 11.8234 23.9846"
          stroke="#FFCEC3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="0.7"
        />
      </mask>
      <g mask="url(#mask0_302_2)">
        <path
          d="M14.9922 24.1095C20.58 24.1095 25.1098 19.5833 25.1098 14C25.1098 8.41668 20.58 3.8905 14.9922 3.8905C9.40439 3.8905 4.87459 8.41668 4.87459 14C4.87459 19.5833 9.40439 24.1095 14.9922 24.1095Z"
          fill="#FFCEC3"
        />
      </g>
      <path
        d="M20.2857 6H1.71429C1.3198 6 1 6.3078 1 6.6875V16.3125C1 16.6922 1.3198 17 1.71429 17H20.2857C20.6802 17 21 16.6922 21 16.3125V6.6875C21 6.3078 20.6802 6 20.2857 6Z"
        fill="none"
        stroke="#FF7870"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 15C12.6569 15 14 13.6569 14 12C14 10.3431 12.6569 9 11 9C9.34315 9 8 10.3431 8 12C8 13.6569 9.34315 15 11 15Z"
        fill="none"
        stroke="#FF7870"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15 6L21 11" fill="none" stroke="#FF7870" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 17L21 12" fill="none" stroke="#FF7870" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 6L1 11" fill="none" stroke="#FF7870" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 17L1 12" fill="none" stroke="#FF7870" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
});
